// libs
import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';

// styles
import { Container, ProductInfo, Header, NonCollapsible } from './styles';

// component
import DescriptionRow from './components/DescriptionRow';
import APlusContent from 'shared/layouts/DetailsPage/components/ProductInfo/components/APlusContent/Desktop/index';
import APlusContentMobile from './components/APlusContent/index';
import DelayedRenderer from 'shared/components/DelayedRenderer';
import ResponsibleTags from './components/ResponsibleTags';

// helpers
import { getTransformedInfo } from './helpers';
import { useResponsiveContext } from 'shared/components/ResponsiveLoader/ResponsiveContext';

// types
import { IWidget } from 'shared/layouts/DetailsPage/components/ProductInfo/components/ProductDescription/types';

// constants
import { PRODUCT_INFO_TITLE } from 'shared/layouts/DetailsPage/constants';
import { WIDGET_TYPES } from 'shared/layouts/DetailsPage/components/ProductInfo/components/ProductDescription/constants';
import { BREAKPOINTS } from 'shared/styles/base';

// selectors
import { getSelectedSKUDataPDPSections } from 'shared/store/details/selectors';

function ProductDescription() {
  const productInfo = useSelector(getSelectedSKUDataPDPSections);
  const { deviceWidth } = useResponsiveContext();

  const isDesktop: boolean = deviceWidth >= BREAKPOINTS.DESKTOP;
  const transformedProductInfo = useMemo(() => getTransformedInfo(productInfo), [productInfo]);

  const getWidgetComponent = (widget: IWidget, index: number) => {
    const type = widget.widget_type;

    switch (type) {
      case WIDGET_TYPES.parentWidget:
      case WIDGET_TYPES.plainCollapsableWidget:
      case WIDGET_TYPES.attributeWidget:
        return <DescriptionRow widget={widget} key={`descriptionRow-${index}`} />;
    }
  };
  return (
    <Container data-test="product-description" data-at="product-description">
      <Header>{PRODUCT_INFO_TITLE}</Header>

      <NonCollapsible>
        <ResponsibleTags className="nonCollapsibleWidget" isMobile={!isDesktop} />

        {isDesktop === true && <APlusContent className="nonCollapsibleWidget" />}

        <DelayedRenderer>
          {isDesktop === false && <APlusContentMobile className="nonCollapsibleWidget" />}
        </DelayedRenderer>
      </NonCollapsible>

      <ProductInfo data-test="new-description">
        {transformedProductInfo.map((widget: any, index) => {
          return getWidgetComponent(widget, index);
        })}
      </ProductInfo>
    </Container>
  );
}

export default memo(ProductDescription);
